var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 331.493 331.493",
    style: {
      enableBackground: "new 0 0 331.493 331.493"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M298.761,57.093l-101.2-54.8c-9.6-5.2-22.8-1.2-28,8.4l-59.2,110h-72c-9.2,0-16.4,7.2-16.4,16.4v28.8v149.2    c0,9.2,7.2,16.4,16.4,16.4h230c9.2,0,16.4-7.2,16.4-16.4v-41.6h6.8c3.6,0,6.4-2.8,6.4-6.4v-47.6c0-3.6-2.8-6.4-6.4-6.4h-6.8v-46.8    c0-7.6-5.6-14.4-12.8-16l35.2-65.2C312.361,75.093,308.761,62.693,298.761,57.093z M226.761,32.693l-63.2,117.2h-18l67.6-124.4    L226.761,32.693z M181.161,16.693c2-3.6,6.8-5.2,10.4-3.2l10,5.6l-70.4,130.8h-22L181.161,16.693z M34.361,136.693    c0-1.2,1.6-3.2,3.6-3.2h65.2l-8.8,16h-56.4c-1.2,0-2.4,0-3.6,0.4V136.693z M271.561,315.093c0,2-1.6,3.6-3.6,3.6h-230    c-2,0-3.6-1.6-3.6-3.6v-148.8c0-2,1.6-3.6,3.6-3.6h60.4h25.6h46.8h90h6.8c2,0,3.6,1.6,3.6,3.6v46.8h-24.4v0    c-10.8,0-19.2,8.8-19.2,19.2v22c0,10.8,8.8,19.2,19.2,19.2h24.8V315.093z M284.361,225.893h0.4v34.8h-0.4h-37.6    c-3.6,0-6.4-2.8-6.4-6.4v-22c0-3.6,2.8-6.4,6.4-6.4H284.361z M295.561,78.693l-38.4,71.2h-79.2l60-110.8l54.4,29.6    C296.361,70.293,297.561,75.093,295.561,78.693z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M271.161,72.693l-3.2-1.6c-8-4.4-18.8-1.2-23.2,6.8l-4,7.6c-2,4-2.8,8.8-1.2,13.2c1.2,4.4,4.4,8,8.4,10l3.2,1.6    c2.4,1.2,5.2,2,8,2c6.4,0,12-3.6,15.2-8.8l4-7.6C282.361,87.493,279.161,77.093,271.161,72.693z M266.761,89.893l-4,7.6    c-1.2,2-4,2.8-6,1.6l-3.2-2c-0.8-0.4-1.6-1.6-2-2.4c-0.4-1.2-0.4-2.4,0.4-3.2l4-7.6c0.8-1.2,2.4-2.4,4-2.4c0.8,0,1.2,0,2,0.4    l3.2,1.6C266.761,85.093,267.561,87.493,266.761,89.893z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.a7f8392e1eead915eef85cb1862603fb.svg";
export { ForwardRef as ReactComponent };